/*!
 * Copyright © 2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Action } from '@ngrx/store';
import { ESidePanelContent } from '../../models';

export enum ESidePanelActions {
  OpenSidePanel = '[ESidePanel] Open Side Panel',
  CloseSidePanel = '[ESidePanel] Close Side Panel',
  UpdateShouldOffsetForSidePanel = '[ESidePanel] Update Should Offset For Side Panel'
}

export class OpenSidePanel implements Action {
  public readonly type = ESidePanelActions.OpenSidePanel;

  constructor(public payload: ESidePanelContent) {}
}

export class CloseSidePanel implements Action {
  public readonly type = ESidePanelActions.CloseSidePanel;
}

export class UpdateShouldOffsetForSidePanel implements Action {
  public readonly type = ESidePanelActions.UpdateShouldOffsetForSidePanel;

  constructor(public payload: boolean) {}
}

export type SidePanelActions = OpenSidePanel | CloseSidePanel | UpdateShouldOffsetForSidePanel;
